/**
 * The two public values the browser needs, read once and validated loudly.
 *
 * They are public by design (a Supabase publishable key is meant to sit in a
 * client), and they are the *only* configuration this bundle carries: every
 * secret stays on the API Worker. Missing configuration throws at start-up
 * rather than at the first login, because a blank screen with a console error
 * is easier to diagnose than an auth call that fails for no visible reason.
 *
 * Both `VITE_` and `NEXT_PUBLIC_` are accepted so the repo keeps one .env.local
 * through the transition; the `NEXT_PUBLIC_` half retires at T18.
 */
function required(name: string, ...values: (string | undefined)[]): string {
  const value = values.find((candidate) => candidate && candidate.length > 0);
  if (!value) {
    throw new Error(
      `Missing ${name}. Set it in .env.local (VITE_ or NEXT_PUBLIC_ prefix).`,
    );
  }
  return value;
}

const env = import.meta.env;

export const SUPABASE_URL = required(
  "SUPABASE_URL",
  env.VITE_SUPABASE_URL as string | undefined,
  env.NEXT_PUBLIC_SUPABASE_URL as string | undefined,
);

export const SUPABASE_PUBLISHABLE_KEY = required(
  "SUPABASE_PUBLISHABLE_KEY",
  env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined,
  env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY as string | undefined,
);
